<template>
  <div class="main-loading-screen">
    <loading-spinner/>
    <p>Loading Serato Visualizer</p>
  </div>
</template>

<script setup lang="ts">
import LoadingSpinner from '@/components/LoadingSpinner.vue'
</script>

<style lang="scss">
.main-loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $white;
  gap: 2px;
  >p {
    font-family: $font-regular;
    font-size: 18px;
  }
}
</style>
